module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news"
    }
  }, [_c('vheader'), _c('mobile-nav'), _c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu_li",
    class: {
      'active': !_vm.type
    },
    on: {
      "click": function($event) {
        return _vm.changeType()
      }
    }
  }, [_vm._v("全部")]), _c('div', {
    staticClass: "menu_li",
    class: {
      'active': _vm.type === 'workshop'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('workshop')
      }
    }
  }, [_vm._v("前沿工作坊")]), _c('div', {
    staticClass: "menu_li",
    class: {
      'active': _vm.type === 'camp'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('camp')
      }
    }
  }, [_vm._v("超频之旅")]), _c('div', {
    staticClass: "menu_li",
    class: {
      'active': _vm.type === 'study'
    },
    on: {
      "click": function($event) {
        return _vm.changeType('study')
      }
    }
  }, [_vm._v("近场研究")])]), _c('div', {
    staticClass: "news-wapper",
    attrs: {
      "id": "waterfall"
    }
  }, _vm._l((_vm.activities), function(item) {
    return _c('article', {
      key: item.id,
      staticClass: "news-item"
    }, [_c('div', {
      staticClass: "banner",
      style: ({
        backgroundImage: 'url(' + item.avatar_url + '?imageView2/1/w/1069/h/620/interlace/1/q/88/interlace/1/)'
      })
    }, [_c('div', {
      staticClass: "activity-type"
    }, [_c('div', {
      staticClass: "en"
    }, [_vm._v("FRONTIER"), _c('br'), _vm._v(_vm._s(item.activity_type))]), _c('div', {
      staticClass: "cn"
    }, [_vm._v(_vm._s(_vm._f("getCN")(item.activity_type)))])])]), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "activity-content"
    }, [_c('h4', [_vm._v(_vm._s(item.title))]), _c('p', [_vm._v(_vm._s(item.description))])]), (item.guests) ? _c('div', {
      staticClass: "activity-guests"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("特邀嘉宾")]), _c('div', {
      staticClass: "guests"
    }, _vm._l((item.guests), function(guest) {
      return _c('div', {
        staticClass: "guest"
      }, [_c('div', {
        staticClass: "avatar"
      }, [_c('img', {
        attrs: {
          "src": ((guest.avatar_url) + "?imageView2/2/w/100/interlace/1/q/88/interlace/1/")
        }
      })]), _c('div', {
        staticClass: "info"
      }, [_c('p', {
        staticClass: "title"
      }, [_vm._v(_vm._s(guest.name))]), _c('p', {
        staticClass: "from"
      }, [_vm._v(_vm._s(guest.company))]), _c('p', {
        staticClass: "position"
      }, [_vm._v(_vm._s(guest.duty))])])])
    }), 0)]) : _vm._e(), _c('div', {
      staticClass: "activity-meta"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": item.article_link,
        "target": "_blank"
      }
    }, [_vm._v("了解更多 >")]), _c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatTime")(item.activity_time)))])])])])
  }), 0)])]), _c('vfooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4250a33e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/News.vue
// module id = 199
// module chunks = 1